interface TableLoadingPrerequisite {
  loading: boolean;
  ready: boolean;
}

/**
 * True only for the first empty load (or while required prerequisites are not ready).
 * Use this instead of raw `loadingInitial` to avoid unmounting table headers on filter refresh.
 */
export function useTableInitialLoading(
  loadingInitial: boolean,
  itemCount: number,
  prerequisites: TableLoadingPrerequisite[] = [],
): boolean {
  const prerequisitesBlocking = prerequisites.some((p) => p.loading && !p.ready);
  return prerequisitesBlocking || (loadingInitial && itemCount === 0);
}
